module.exports = (__webpack_require__(17050))(3671);